import { API_BASE_URL } from "../urls.api";

export const GET_TASKS = `${API_BASE_URL}/tasks`;
export const CREATE_TASK = `${API_BASE_URL}/tasks`;
export const TASKS_URL = `${API_BASE_URL}/tasks`;
